module.exports = __webpack_public_path__ + "img/weixincode.751bb6fe.jpg";